module.exports = __webpack_public_path__ + "static/img/icon_top@2x.8162e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio/icon_top@2x.png
// module id = TEK4
// module chunks = 69